<div class="privacy-content" [innerHTML]="dataProtectionHtml"></div>
